import { useEffect, useState } from "react";

export default function useIsIntersecting<T extends Element>(props: {
  ref: React.MutableRefObject<T | null>;
  intersectionObserverInit?: IntersectionObserverInit;
}) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (!entry) {
        return;
      }
      setIsIntersecting(entry.isIntersecting);
    }, props.intersectionObserverInit);

    if (props.ref.current) {
      observer.observe(props.ref.current);
    }

    return () => {
      if (props.ref.current) {
        observer.unobserve(props.ref.current);
      }
    };
  }, [props.ref, props.intersectionObserverInit]);

  return isIntersecting;
}
